var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YoutubeLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.75 11L9.625 8.25V13.75L13.75 11Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.0625 11C2.0625 13.5609 2.32891 15.0562 2.52656 15.8297C2.58106 16.0395 2.68412 16.2336 2.82743 16.3963C2.97073 16.5591 3.15027 16.6858 3.35156 16.7664C6.23047 17.8664 11 17.8406 11 17.8406C11 17.8406 15.7695 17.8664 18.6484 16.7664C18.8497 16.6858 19.0293 16.5591 19.1726 16.3963C19.3159 16.2336 19.4189 16.0395 19.4734 15.8297C19.6711 15.0562 19.9375 13.5609 19.9375 11C19.9375 8.43904 19.6711 6.94373 19.4734 6.17029C19.4189 5.96043 19.3159 5.76632 19.1726 5.60361C19.0293 5.4409 18.8497 5.31415 18.6484 5.23357C15.7695 4.13357 11 4.15935 11 4.15935C11 4.15935 6.23047 4.13357 3.35156 5.23357C3.15027 5.31415 2.97073 5.4409 2.82743 5.60361C2.68412 5.76632 2.58106 5.96043 2.52656 6.17029C2.32891 6.94373 2.0625 8.43904 2.0625 11Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtubeLogo.1c6611fed9afbb96b70375f3d3a8c44c.svg";
export { ForwardRef as ReactComponent };